import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button, Select } from '../../../../components/base';
import { FINANCE_NON_BUDGET_TABLE_FIELDS } from '../../../../constants/finance/budgeting/nonBudget.constant';
import { commaFormatted, dateFormat } from '../../../../utils/transformer.util';

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

const monthOptions = () => {
  const options = [{ value: '', label: 'Semua' }];
  const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
  for (let i = 0; i < 12; i += 1) {
    options.push({ value: i, label: months[i] });
  }
  return options;
};

const yearOptions = () => {
  const d = new Date();
  const year = d.getFullYear();
  const options = [{ value: '', label: 'Semua' }];
  for (let i = 2020; i <= year; i += 1) {
    options.push({ value: i, label: i });
  }
  return options;
};

const isPostedOptions = [
  { value: '', label: 'Semua' },
  { value: 'PENDING', label: 'Menunggu Persetujuan' },
  { value: 'REJECTED', label: 'Ditolak' },
  { value: 'APPROVED', label: 'Disetujui' },
];

export default class NonBudget extends PureComponent {
  constructor(props) {
    super(props);
    const { user } = props;
    const { user_group } = user;
    const { permissions = [] } = user_group;
    this.onClickAdd = this.onClickAdd.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.getData = this.getData.bind(this);
    this.renderRows = this.renderRows.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.getUnitOptions = this.getUnitOptions.bind(this);

    this.state = {
      permissions,
      content: initialContent,
      listAmount: 5,
      filters: {},
      unitOptions: [],
    };
  }

  componentDidMount() {
    this.getUnitOptions();
    this.getData();
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/keuangan/penganggaran/tambah-non-anggaran', { isEdit: false });
  }

  onClickEdit(val) {
    const { history } = this.props;
    const { permissions } = this.state;
    history.push('/dashboard/keuangan/penganggaran/edit-non-anggaran', { data: val, isEdit: permissions.includes('edit_non_budget') });
  }

  onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }), () => this.getData());
  }

  async getData() {
    const { handleGetNonBudget } = this.props;
    const { filters } = this.state;
    console.log('filters', filters);
    const res = await handleGetNonBudget({
      filters
    });
    this.setState(prevState=> ({
      ...prevState,
      content: {
        ...prevState.content,
        list: res,
      },
    }));
  }

  async getUnitOptions() {
    const { handleGetUnitOptions } = this.props;
    const res = await handleGetUnitOptions();
    if (res) {
      this.setState(prevState => ({
        ...prevState,
        unitOptions: res.map((item) => ({
          value: item.id,
          label: item.title,
        }))
      }));
    }
  }

  renderButtons(row) {
    const { permissions } = this.state;
    return (
      <>
        { permissions.includes('edit_non_budget') && (
          <Button
            title="Edit"
            onClick={() => this.onClickEdit(row)}
          />
        )}
        { !permissions.includes('edit_non_budget') && (
          <Button
            title="Lihat"
            onClick={() => this.onClickEdit(row)}
          />
        )}
      </>
    );
  }

  renderRows() {
    const { content = {}, permissions } = this.state;
    const { result = [] } = content.list;

    return (
      <>
        { result.map((row, idx) => (
          <tr
            key={row.id}
            onClick={() => this.onClickEdit(row)}
          >
            <td>{idx + 1}</td>
            <td>{row.file_number}</td>
            <td>{row.school_unit[0].school_unit.name}</td>
            <td>{dateFormat(row.date)}</td>
            <td className="nominal">{ commaFormatted(row.total) }</td>
            <td>{row.status}</td>
            <td>
              { this.renderButtons(row) }
            </td>
          </tr>
        ))}
      </>
    );
  }

  render() {
    const { permissions, filters, unitOptions } = this.state;
    const {
      month = '',
      year = '',
      unit_id = '',
      status = '',
    } = filters
    return (
      <div className="non-budget">
        { permissions.includes('edit_non_budget') && (
          <Button
            title="Tambah Non Anggaran"
            onClick={this.onClickAdd}
          />
        )}
        <div className="non-budget__content">
          <div className="table-filters">
            { (permissions.includes('view_all_non_budget') || permissions.includes('view_units_non_budget')) && (
              <Select
                placeholder="Kode Unit"
                name="unit_id"
                value={unit_id}
                data={unitOptions}
                onChange={this.onChangeFilter}
              />
            )} 
            <Select
              placeholder="Bulan Pengajuan"
              name="month"
              value={month}
              data={monthOptions()}
              onChange={this.onChangeFilter}
            />
            <Select
              placeholder="Tahun Pengajuan"
              name="year"
              value={year}
              data={yearOptions()}
              onChange={this.onChangeFilter}
            />
            { (permissions.includes('view_all_non_budget') || permissions.includes('view_units_non_budget')) && (
              <Select
                placeholder="Status Pengajuan"
                name="status"
                value={status}
                data={isPostedOptions}
                onChange={this.onChangeFilter}
              />
            )}
          </div>
          <table className="table">
            <thead>
              <tr>
              {
                FINANCE_NON_BUDGET_TABLE_FIELDS.label.map((field, idx) => (
                  <th key={`table_th_${idx}`}>{field}</th>
                ))
              }
              </tr>
            </thead>
            <tbody>
              { this.renderRows() }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

NonBudget.propTypes = {
  handleGetNonBudget: PropTypes.func,
  history: PropTypes.object.isRequired,
  user: PropTypes.object,
};
NonBudget.defaultProps = {
  handleGetNonBudget: noop,
  user: null,
};
